<template>
	<v-btn
		class="mb-2"
		height="55"
		width="70"
		:class="color"
		:disabled="channelData.mode === 'hotkey_control'"
		@click="buttonPressed()"
	>
		{{
			channelData.mode === "track_control" || channelData.mode === "mic_control"
				? position === "button3"
					? "ON"
					: "OFF"
				: ""
		}}
	</v-btn>
</template>

<script>
/* Enums */
import EventStatus from "@/enums/EventStatus";
import ChainTypes from "@/enums/ChainTypes";
import SequencerModes from "@/enums/SequencerModes";

/* Libraries */
import emitter from "@/emitter";

export default {
	name: "BottomButton",

	props: ["position", "channelData"],

	computed: {
		isUserOnAir() {
			return this.$store.getters.isUserOnAir(this.channelData.peerID);
		},

		color() {
			if (this.channelData.mode === "hotkey_control") {
				return "black";
			}
			if (this.position === "button3") {
				// mode == track_control
				if (this.channelData.mode === "track_control") {
					if (this.channelData.trackStatus === EventStatus.Current) {
						return "green";
					} else {
						return "grey";
					}
				}

				// mode == master
				if (this.channelData.mode === "master") {
					if (this.channelData.trackStatus === EventStatus.Current) {
						return "green";
					} else if (this.channelData.trackStatus === EventStatus.Paused) {
						return "yellow";
					} else if (
						this.channelData.chainType === ChainTypes.Stop &&
						this.channelData.trackStatus !== EventStatus.Paused
					) {
						return "pink-lighten-3";
					} else if (this.channelData.chainType === ChainTypes.Stop) {
						return "red";
					}
				}

				if (this.channelData.mode === "mic_control") {
					if (this.isUserOnAir) {
						return "green";
					} else {
						return "grey";
					}
				}
			} else if (this.position === "button4") {
				// mode == track_control
				if (this.channelData.mode === "track_control") {
					if (this.channelData.trackStatus === EventStatus.Current) {
						return "grey";
					} else {
						return "blue";
					}
				}

				//mode === microphone_control
				if (this.channelData.mode === "mic_control") {
					if (this.isUserOnAir) {
						return "grey";
					} else {
						return "blue";
					}
				}

				// mode == master
				if (this.channelData.mode === "master") {
					if (this.channelData.sequencerMode === SequencerModes.Auto) {
						return "grey";
					} else if (this.channelData.sequencerMode === SequencerModes.Manual) {
						if (this.channelData.trackStatus === EventStatus.Current) {
							return "yellow";
						} else if (this.channelData.trackStatus === EventStatus.Paused) {
							return "red-lighten-3";
						} else {
							return "green";
						}
					} else if (this.channelData.sequencerMode === SequencerModes.LiveAssist) {
						if (
							this.channelData.chainType === ChainTypes.Stop &&
							this.channelData.trackStatus !== EventStatus.Paused
						) {
							return "yellow";
						} else if (this.channelData.trackStatus === EventStatus.Current) {
							return "pink-lighten-3";
						} else if (this.channelData.trackStatus === EventStatus.Paused) {
							return "red-lighten-3";
						} else {
							return "green";
						}
					}
				}
			}
			return null;
		}
	},

	watch: {
		color(value) {
			if (!this.isDisabled) {
				this.setControllerColor(value);
			} else {
				this.setControllerColor("black");
			}
		}
	},

	mounted() {
		this.initializeButton();
		emitter.on("button:pressed", this.buttonPressed);
		emitter.on("reinitializeMIDI", this.initializeButton);
		emitter.on("updateControllerColor", this.updateControllerColor);
	},

	beforeUnmount() {
		emitter.off("button:pressed", this.buttonPressed);
		emitter.off("reinitializeMIDI", this.initializeButton);
		emitter.off("updateControllerColor", this.updateControllerColor);
	},

	methods: {
		initializeButton() {
			if (!this.isDisabled) {
				emitter.emit("onSetButtonColor", {
					assignedChannel: this.channelData.assignment,
					button: this.position,
					color: this.color
				});
			} else {
				emitter.emit("onSetButtonColor", {
					assignedChannel: this.channelData.assignment,
					button: this.position,
					color: "black"
				});
			}
		},

		buttonPressed(ev) {
			if (ev && this.channelData.channelNumber !== ev.channel) {
				return;
			}

			if (this.position === "button3" && (ev ? ev.button === "button3" : true)) {
				if (this.channelData.mode === "master" && (ev ? ev.mode === "master" : true)) {
					this.setSequencerAction({action: "PlayNext", msg: {EventID: null}});
				} else if (this.channelData.mode === "track_control" && (ev ? ev.mode === "track_control" : true)) {
					this.channelData.mainMidiBC.postMessage({
						type: "playPot",
						state: true,
						channel: this.channelData.channelNumber
					});
				} else if (this.channelData.mode === "mic_control" && (ev ? ev.mode === "mic_control" : true)) {
					this.channelData.mainMidiBC.postMessage({
						type: "toggleUserAirState",
						on: true,
						user: this.channelData.peerID
					});
				}
			} else if (this.position === "button4" && (ev ? ev.button === "button4" : true)) {
				if (this.channelData.mode === "master" && (ev ? ev.mode === "master" : true)) {
					if (this.channelData.sequencerMode === SequencerModes.Manual) {
						if (this.channelData.trackStatus === EventStatus.Current) {
							this.setSequencerAction({action: "Pause", msg: {EventID: null}});
						} else if (this.channelData.trackStatus === EventStatus.Paused) {
							this.setSequencerAction({action: "Stop", msg: {EventID: null}});
						} else {
							this.setSequencerAction({action: "PlayNext", msg: {EventID: null}});
						}
					} else if (this.channelData.sequencerMode === SequencerModes.LiveAssist) {
						if (
							this.channelData.chainType === ChainTypes.Stop &&
							this.channelData.trackStatus !== EventStatus.Paused
						) {
							this.setSequencerAction({action: "Pause", msg: {EventID: null}});
						} else if (this.channelData.trackStatus === EventStatus.Current) {
							this.setSequencerAction({action: "End", msg: {EventID: null}});
						} else if (this.channelData.trackStatus === EventStatus.Paused) {
							this.setSequencerAction({action: "Stop", msg: {EventID: null}});
						} else {
							this.setSequencerAction({action: "PlayNext", msg: {EventID: null}});
						}
					}
				} else if (this.channelData.mode === "track_control" && (ev ? ev.mode === "track_control" : true)) {
					this.channelData.mainMidiBC.postMessage({
						type: "playPot",
						state: false,
						channel: this.channelData.channelNumber
					});
				} else if (this.channelData.mode === "mic_control" && (ev ? ev.mode === "mic_control" : true)) {
					this.channelData.mainMidiBC.postMessage({
						type: "toggleUserAirState",
						on: false,
						user: this.channelData.peerID
					});
				}
			}
		},

		setSequencerAction(payload) {
			emitter.emit("midi:setSequencerAction", payload);
		},

		setControllerColor(color) {
			emitter.emit("onSetButtonColor", {
				assignedChannel: this.channelData.assignment,
				button: this.position,
				color: color
			});
		},

		updateControllerColor(ev) {
			if (this.channelData.assignment === ev.newlyAssignedChannel) {
				this.setControllerColor(this.color);
			}
		}
	}
};
</script>

<style scoped lang="scss">
.v-btn {
	position: relative;
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	border: 2px solid transparent;
	background: linear-gradient(145deg, #333, #222);
	box-shadow:
		0 2px 4px rgba(0, 0, 0, 0.4),
		inset 0 1px 2px rgba(255, 255, 255, 0.03),
		inset 0 -2px 4px rgba(0, 0, 0, 0.35),
		0 0 4px currentColor,
		0 0 6px currentColor;

	&::before {
		content: "";
		position: absolute;
		top: 8%;
		left: 8%;
		width: 84%;
		height: 35%;
		background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), transparent);
		border-radius: 30% 30% 20% 20%;
		pointer-events: none;
	}

	&:active {
		transform: scale(0.95);
		box-shadow:
			inset 0 2px 4px rgba(255, 255, 255, 0.08),
			inset 0 -4px 6px rgba(0, 0, 0, 0.5),
			0 0 4px currentColor,
			0 0 8px currentColor;
	}

	&.green {
		background-color: $ihm-green;
		color: $ihm-green;
		border-color: $ihm-green;
	}

	&.yellow {
		background-color: $ihm-yellow;
		color: $ihm-yellow;
		border-color: $ihm-yellow;
	}

	&.red {
		background-color: $ihm-red;
		color: $ihm-red;
		border-color: $ihm-red;
	}

	&.pink-lighten-3 {
		background-color: $ihm-pink;
		color: $ihm-pink;
		border-color: $ihm-pink;
	}

	&.red-lighten-3 {
		background-color: $ihm-red2;
		color: $ihm-red2;
		border-color: $ihm-red2;
	}

	&.white {
		background-color: $ihm-white;
		color: $ihm-white;
		border-color: $ihm-white;
	}

	&.grey {
		background-color: $ihm-grey-2;
		color: $ihm-grey-2;
		border-color: $ihm-grey-2;
	}

	&.blue {
		background-color: $ihm-blue;
		color: $ihm-blue;
		border-color: $ihm-blue;
	}
}
</style>
